import React, {Dispatch, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';
import FilterBySixMonths from './Components/FilterBySixMonths';
import {RequestBillingTransactions} from '../../types/TypesUserAccounts';
import FilterWrapper from './FilterWrapper';

interface Props {
	active: boolean;
	setActive: (b: boolean) => void;
	setFilters: Dispatch<SetStateAction<RequestBillingTransactions>>;
}

const TransactionsFilter: React.FC<Props> = ({
	active,
	setActive,
	setFilters,
}) => {
	const {t} = useTranslation();
	const handleSubmit = (values: any) => {
		setFilters({...values, offset: 0});
		setActive(false);
	};

	const handleReset = () => {
		setFilters({month: '', offset: 0});
	};

	return (
		<FilterWrapper
			active={active}
			initialValues={{month: ''}}
			onSubmit={handleSubmit}
			onReset={handleReset}
			submitButtonText={t('Застосувати')}
			resetButtonText={t('Очистити')}
		>
			{({setFieldValue}) => <FilterBySixMonths setFieldValue={setFieldValue} />}
		</FilterWrapper>
	);
};

export default TransactionsFilter;
